export const getBehaviourSuccessRatePerOperatorRespMaritime = () => {
  return [
    {
      countEventsPerformablePostSignol: 22,
      countEventsPerformedPostSignol: 0,
      successRateActual: 36,
      successRatePreSignol: 0,
    },
    {
      countEventsPerformablePostSignol: 25,
      countEventsPerformedPostSignol: 13,
      successRateActual: 61,
      successRatePreSignol: 11,
    },
    {
      countEventsPerformablePostSignol: 26,
      countEventsPerformedPostSignol: 6,
      successRateActual: 48,
      successRatePreSignol: 23,
    },
    {
      countEventsPerformablePostSignol: 49,
      countEventsPerformedPostSignol: 13,
      successRateActual: 26.53,
      successRatePreSignol: 25,
    },
    {
      countEventsPerformablePostSignol: 18,
      countEventsPerformedPostSignol: 5,
      successRateActual: 50,
      successRatePreSignol: 25,
    },
    {
      countEventsPerformablePostSignol: 30,
      countEventsPerformedPostSignol: 10,
      successRateActual: 74,
      successRatePreSignol: 33,
    },
    {
      countEventsPerformablePostSignol: 38,
      countEventsPerformedPostSignol: 13,
      successRateActual: 71,
      successRatePreSignol: 34,
    },
    {
      countEventsPerformablePostSignol: 17,
      countEventsPerformedPostSignol: 6,
      successRateActual: 60,
      successRatePreSignol: 35,
    },
    {
      countEventsPerformablePostSignol: 34,
      countEventsPerformedPostSignol: 15,
      successRateActual: 77,
      successRatePreSignol: 44,
    },
    {
      countEventsPerformablePostSignol: 33,
      countEventsPerformedPostSignol: 8,
      successRateActual: 59,
      successRatePreSignol: 47,
    },
    {
      countEventsPerformablePostSignol: 2,
      countEventsPerformedPostSignol: 1,
      successRateActual: 54,
      successRatePreSignol: 50,
    },
    {
      countEventsPerformablePostSignol: 16,
      countEventsPerformedPostSignol: 8,
      successRateActual: 80,
      successRatePreSignol: 50,
    },
    {
      countEventsPerformablePostSignol: 9,
      countEventsPerformedPostSignol: 5,
      successRateActual: 77,
      successRatePreSignol: 55,
    },
    {
      countEventsPerformablePostSignol: 26,
      countEventsPerformedPostSignol: 15,
      successRateActual: 89,
      successRatePreSignol: 57,
    },
    {
      countEventsPerformablePostSignol: 60,
      countEventsPerformedPostSignol: 0,
      successRateActual: 65,
      successRatePreSignol: 60,
    },
    {
      countEventsPerformablePostSignol: 36,
      countEventsPerformedPostSignol: 23,
      successRateActual: 88,
      successRatePreSignol: 62,
    },
    {
      countEventsPerformablePostSignol: 22,
      countEventsPerformedPostSignol: 15,
      successRateActual: 88,
      successRatePreSignol: 68,
    },
    {
      countEventsPerformablePostSignol: 33,
      countEventsPerformedPostSignol: 25,
      successRateActual: 75.76,
      successRatePreSignol: 72,
    },
    {
      countEventsPerformablePostSignol: 23,
      countEventsPerformedPostSignol: 18,
      successRateActual: 88.26,
      successRatePreSignol: 78,
    },
    {
      countEventsPerformablePostSignol: 23,
      countEventsPerformedPostSignol: 12,
      successRateActual: 72.17,
      successRatePreSignol: 80,
    },
    {
      countEventsPerformablePostSignol: 11,
      countEventsPerformedPostSignol: 8,
      successRateActual: 82.73,
      successRatePreSignol: 83,
    },
    {
      countEventsPerformablePostSignol: 12,
      countEventsPerformedPostSignol: 9,
      successRateActual: 75,
      successRatePreSignol: 90,
    },
    {
      countEventsPerformablePostSignol: 36,
      countEventsPerformedPostSignol: 0,
      successRateActual: 90,
      successRatePreSignol: 90,
    },
    {
      countEventsPerformablePostSignol: 33,
      countEventsPerformedPostSignol: 15,
      successRateActual: 95.45,
      successRatePreSignol: 90,
    },
  ];
};
